/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutboundConfigUpdateRequest
 */
export interface OutboundConfigUpdateRequest {
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof OutboundConfigUpdateRequest
     */
    outboundConfig?: { [key: string]: any; };
}

/**
 * Check if a given object implements the OutboundConfigUpdateRequest interface.
 */
export function instanceOfOutboundConfigUpdateRequest(value: object): value is OutboundConfigUpdateRequest {
    return true;
}

export function OutboundConfigUpdateRequestFromJSON(json: any): OutboundConfigUpdateRequest {
    return OutboundConfigUpdateRequestFromJSONTyped(json, false);
}

export function OutboundConfigUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutboundConfigUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'outboundConfig': json['outboundConfig'] == null ? undefined : json['outboundConfig'],
    };
}

export function OutboundConfigUpdateRequestToJSON(json: any): OutboundConfigUpdateRequest {
    return OutboundConfigUpdateRequestToJSONTyped(json, false);
}

export function OutboundConfigUpdateRequestToJSONTyped(value?: OutboundConfigUpdateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'outboundConfig': value['outboundConfig'],
    };
}

